var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"c-error-view"},[_c('h1',{staticClass:"u-a4"},[_vm._v("404")]),_c('h2',{staticClass:"u-a3"},[_vm._v(_vm._s(_vm.$t('Ova stranica ne postoji')))]),_c('a-button',{attrs:{"type":"primary"},on:{"click":_vm.goToHome}},[_vm._v(_vm._s(_vm.$t('Vrati se na početnu')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }